import { render } from "./RestaurantMenuItem.vue?vue&type=template&id=17542e71&scoped=true"
import script from "./RestaurantMenuItem.vue?vue&type=script&lang=js"
export * from "./RestaurantMenuItem.vue?vue&type=script&lang=js"

import "./RestaurantMenuItem.vue?vue&type=style&index=0&id=17542e71&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-17542e71"]])

export default __exports__